import { useStyles, Button } from '@archipro-design/aria';
import { LinkLight, CheckLine } from '@archipro-design/icons';
import * as S from './DetailPageButtons.style';
import { IslandTooltip } from './IslandTooltip';
import React from 'react';

interface CopyLinkButtonProps {
    url: string;
}

export const CopyLinkButton = ({ url }: CopyLinkButtonProps) => {
    const { css } = useStyles();

    const [clicked, setClicked] = React.useState(false);

    return (
        // "Copied" holds the label up on its own: the confirmation has to be
        // readable after the pointer has moved on.
        <IslandTooltip
            label={clicked ? 'Copied' : 'Copy share link'}
            forceVisible={clicked}
        >
            <Button
                aria-label={clicked ? 'Copied' : 'Copy share link'}
                className={css(S.ActionButton)}
                icon={
                    clicked ? (
                        <CheckLine className={css(S.Copied)} />
                    ) : (
                        <LinkLight />
                    )
                }
                size={20}
                color="white"
                variables={{
                    iconPadding: 0,
                    // 13px at the 1920 design frame. In rem, not a raw px string,
                    // so it scales with the vw-anchored root like the numeric
                    // tokens do; it holds the circle at its original size now
                    // that the icon inside it is smaller.
                    buttonPadding: '0.8125rem',
                    buttonRadius: `50%`,
                }}
                onClick={(event) => {
                    event.preventDefault();
                    navigator.clipboard.writeText(url);
                    setClicked(true);

                    setTimeout(() => {
                        setClicked(false);
                    }, 3000);
                }}
            />
        </IslandTooltip>
    );
};
